(() => {
  const selectors = {
    openPopUpTriger: '.js-item__pop-up-triger',
    closePopUpBtn: '.js-pop-up__close-btn',
    popUpModal: '.js-item__pop-up',
    html: 'html',
  };

  const modalTrigers = [...document.querySelectorAll(selectors.openPopUpTriger)];
  const modals = [...document.querySelectorAll(selectors.popUpModal)];
  const modalCloseBtns = [...document.querySelectorAll(selectors.closePopUpBtn)];
  const htmlEl = document.querySelector(selectors.html);

  modalTrigers.forEach((modalTriger) => {
    modalTriger.addEventListener('click', () => {
      modalTriger.nextElementSibling.classList.add('show');
      htmlEl.classList.add('overflow-hidden');
    });
  })

  function closeModal(modalEl) {
    modalEl.classList.remove('show');
    htmlEl.classList.remove('overflow-hidden');
  }

  modalCloseBtns.forEach((closeBtn) => {
    closeBtn.addEventListener('click', closeModal.bind(this, closeBtn.closest(selectors.popUpModal)));
  });

  modals.forEach((modal) => {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeModal(modal);
      }
    });
  });

  function getdModalwithClass(className) {
    const modal = modals.find((modal) => {
      if (modal.classList.contains(className)) return modal;
    })
    return modal ? modal : 0;
  };

  document.addEventListener('keydown', (e) => {
    const modal = getdModalwithClass('show')
    if (e.code === "Escape" && modal) {
      closeModal(modal);
    }
  });
})();
